
window._ = require('lodash')

try {
    window.$ = window.jQuery = require('jquery')

    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector;
    }

    require('bootstrap-sass')

    require('bootstrap-select')

    require('datatables.net')

    require('datatables.net-bs')

    require('jquery-validation')

    require('jquery-datetimepicker')

    require('form-serializer')

    require('codemirror')

    require('summernote')

    require('url-polyfill')

    require('jquery.initialize')

    require('jsignature') //do not extract, lib cant find jquery

    require('select2')

    window.datepicker = require('jquery-ui/ui/widgets/datepicker')

    window.moment = require('moment')
    
    window.Handlebars = require('handlebars')
    
    window.Chart = require('chartjs')

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    })
} catch (e) {}

require('./global-functions.js')

require('./components/BackButton.js')
require('./components/BookingFilter.js')
require('./components/Checkout.js')
require('./components/ConfirmModal.js')
require('./components/PaymentPlanSelector.js')
require('./components/ClosedDatesField.js')
require('./components/ContactPlanContainer.js')
require('./components/ContactTypeSelector.js')
require('./components/DateField.js')
require('./components/DynamicFormList.js')
require('./components/EventChildList.js')
require('./components/GenerateRegistersModal.js')
require('./components/PayPlayChildList.js')
require('./components/FormSubmitButton.js')
require('./components/HtmlInput.js')
require('./components/HolidayCampChildList.js')
require('./components/InvoiceChargeInput.js')
require('./components/InvoiceCostDisplay.js')
require('./components/InvoiceDelete.js')
require('./components/InvoiceItemSelect.js')
require('./components/InvoiceTotalDisplay.js')
require('./components/LiveDropdown.js')
require('./components/NotesTab.js')
require('./components/NotifyModal.js')
require('./components/PaymentMethodSubmitButton.js')
require('./components/PrintRegistersButton.js')
require('./components/ReportDates.js')
require('./components/SelectAllButton.js')
require('./components/SelectAllMultiSelectButton.js')
require('./components/SlugInput.js')
require('./components/TableExpandAllButton.js')
require('./components/TableFilter.js')
require('./components/ToolTip.js')
require('./components/ValidationStyler.js')
